export const DEFAULT_CUSTOM_LENGTH = 39;
export const DEFAULT_CUSTOM_WAIST = 32;

export const CUSTOM_LENGTH_RANGE = { min: 30, max: 60 };
export const CUSTOM_WAIST_RANGE = { min: 24, max: 50 };

const clampToRange = (value, range, fallback) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return fallback;
  return Math.max(range.min, Math.min(range.max, Math.round(parsed)));
};

const parseExplicitValue = (text, patterns) => {
  for (const pattern of patterns) {
    const match = text.match(pattern);
    if (match) {
      const parsed = Number(match[1]);
      if (Number.isFinite(parsed)) return parsed;
    }
  }
  return null;
};

export const parseCustomMeasurements = (value) => {
  const text = String(value || "");
  const allNumbers = Array.from(text.matchAll(/(\d{2})\s*"?/g)).map((m) => Number(m[1]));

  const explicitLength = parseExplicitValue(text, [
    /\blength\b\s*[:=-]?\s*(\d{2})\s*"?/i,
    /\bL\b\s*[:=-]?\s*(\d{2})\s*"?/i,
  ]);

  const explicitWaist = parseExplicitValue(text, [
    /\bwaist\b\s*[:=-]?\s*(\d{2})\s*"?/i,
    /\bW\b\s*[:=-]?\s*(\d{2})\s*"?/i,
  ]);

  const length = clampToRange(
    explicitLength ?? allNumbers[0] ?? DEFAULT_CUSTOM_LENGTH,
    CUSTOM_LENGTH_RANGE,
    DEFAULT_CUSTOM_LENGTH,
  );

  const waist = clampToRange(
    explicitWaist ?? allNumbers[1] ?? DEFAULT_CUSTOM_WAIST,
    CUSTOM_WAIST_RANGE,
    DEFAULT_CUSTOM_WAIST,
  );

  return { length, waist };
};

export const formatCustomSizeLabel = (length, waist) => {
  const normalizedLength = clampToRange(length, CUSTOM_LENGTH_RANGE, DEFAULT_CUSTOM_LENGTH);
  const normalizedWaist = clampToRange(waist, CUSTOM_WAIST_RANGE, DEFAULT_CUSTOM_WAIST);
  return `CUSTOM: LENGTH ${normalizedLength}" | WAIST ${normalizedWaist}"`;
};
